import { render, staticRenderFns } from "./MainContentLayout.vue?vue&type=template&id=51bd8a73&scoped=true"
import script from "./MainContentLayout.vue?vue&type=script&lang=js"
export * from "./MainContentLayout.vue?vue&type=script&lang=js"
import style0 from "./MainContentLayout.vue?vue&type=style&index=0&id=51bd8a73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bd8a73",
  null
  
)

export default component.exports